import css from 'styled-jsx/css';
import { colors } from '../../config/styles';

const styles = css`
  .container {
    position: fixed;
    bottom: 90px;
    right: 20px;
    z-index: 1000;
    width: 50px;
    height: 50px;

    @mixin tabletToDesktop {
      bottom: 20px;
    }
  }

  .screen {
    width: 100svw;
    height: 100svh;
    background-color: red;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 23;
    background-color: rgba(0, 0, 0, 0.5);

    @mixin phabletToDesktop {
      width: 0;
      height: 0;
      background-color: none;
      position: initial;
    }
  }

  .chat-box {
    position: absolute;
    background-color: ${colors.white.shade1};
    width: 100%;
    padding: 13px 20px 30px;
    bottom: 0;

    @mixin phabletToDesktop {
      height: initial;
      background-color: ${colors.white.shade1};
      border-radius: 10px;
      box-shadow: 1px 0 10px 5px rgba(0, 0, 0, 0.17);
      width: 310px;
      padding: 13px 20px 30px;
      margin-bottom: 10px;
      transform: translate(0, -70px);
      bottom: -6px;
      right: 0;
    }
  }

  .controllers {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20px;

    @mixin phabletToDesktop {
      display: none;
    }
  }
  .bar {
    display: flex;
    justify-content: center;
    width: 40%;
    height: 6px;
    background-color: #b1b2b1;
    border-radius: 13px;
  }
  .close-button {
    position: absolute;
    right: 0;
    width: 20px;
    height: 20px;
    font-size: 19px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url('/a/fa/product/static/styles/svg/HeaderIcons/close.svg');
    background-repeat: no-repeat;
    background-position: center;
  }

  .header {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .logo {
    width: 50px;
    height: 50px;
    margin-right: 8px;
    background-image: url('/a/fa/product/static/styles/svg/whatsapp.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 50px 50px;
  }

  .title {
    color: ${colors.green.shade32};
    margin-bottom: 2px;
    margin-top: 9px;
    font-weight: 700;
    line-height: 1;
  }

  .subtitle {
    font-size: 14px;
    margin-top: 0;
    margin-bottom: 0;
    color: ${colors.gray.shade21};
  }

  .message {
    box-sizing: border-box;
    display: block;
    text-decoration: none;
    width: 100%;
    background-color: ${colors.white.shade1};
    border: 1px solid ${colors.blue.shade5};
    margin-top: 12px;
    padding: 13px;
    text-align: center;
    color: ${colors.blue.shade5};
    border-radius: 20px;
    cursor: pointer;
    font-weight: 700;
    font-size: 13px;
    line-height: 1;
  }
  .message:hover {
    text-decoration: underline;
  }

  .arrow {
    display: none;

    @mixin phabletToDesktop {
      display: initial;
      position: absolute;
      bottom: -10px;
      right: 21px;
      width: 20px;
      height: 20px;
      background-color: ${colors.white.shade1};
      transform: rotate(45deg);
      z-index: -1;
      box-shadow: 3px 3px 4px -1px rgba(0, 0, 0, 0.17);
    }
  }

  .button {
    background: none;
    border: none;
    width: inherit;
    height: inherit;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url('/a/fa/product/static/styles/svg/whatsapp.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 49px 49px;
  }
`;

export { styles };
